module["exports"] = [
  "읍",
  "면",
  "동"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ko/address/street_suffix.js
// module id = 1006
// module chunks = 0